import React from "react";
import { graphql } from "gatsby"
import { siteUrl } from '../shared/utils/siteUrl';
import SEO from "../shared/components/atoms/seo/seo";
import '../shared/styles/index.scss';
import AuthenticationContent from "../components/organisms/authentication-content/authentication-content";

// import SEO from "../shared/components/atoms/seo/seo"

class IndexPage extends React.Component {

  constructor(props) {
    super(props);
  }

  render() {

    return (
      <>
        <SEO
          title={this.props.data.allContentfulPequeninRegistro.nodes[0].metaTitulo}
          description={this.props.data.allContentfulPequeninRegistro.nodes[0].metaDescripcion.metaDescripcion}
          url={siteUrl + '/autenticacion/'}
        />
        <AuthenticationContent contentInfo={this.props.data.allContentfulPequeninRegistro.nodes[0]} />
      </>
    )
  }
}

export const query = graphql`

  query GET_AUTHENTICATION_CONTENT($locale: String!){
    allContentfulPequeninRegistro(filter: {slug: {eq: "inicio-de-sesion/"}, node_locale: {eq: $locale}})  {
        nodes {
          slug
          metaTitulo
          metaDescripcion {
            metaDescripcion
          }
        }
      }
    }
`

export default IndexPage
